module.exports = __webpack_public_path__ + "static/icons/preview2.931cce4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/preview2.jpg
// module id = Ehb/
// module chunks = 1